import { library, dom } from "@fortawesome/fontawesome-svg-core";
import {
    faBars,
    faSearch,
    faArrowLeftLong,
    faX,
    faCaretDown,
    faArrowRightLong,
} from "@fortawesome/free-solid-svg-icons";
import {
    faFacebookF,
    faInstagram,
    faLinkedinIn,
    faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Accordion } from "@doodl/slate";

import Carousel from "./components/carousel";
import Lightbox from "./components/lightbox";

import SearchAndNavDrawer from "./search-and-nav-drawer";

import LazyReactForm from "./components/form";

new SearchAndNavDrawer();

/**
 * Detect whether or not the masthead--actions element is overlapping the main
 * page header elements and apply html classes to it to style as necessary
 */

(function () {
    // Let's not pollute the global scope

    const heroArea = document.querySelector(".page--hero-area");
    const targetToHide = document.querySelector(".backdrop--hide-over-hero");

    if (heroArea && targetToHide) {
        if (!!window.IntersectionObserver) {
            // Intersection Observer is supported

            const observer = new IntersectionObserver(
                (entries, observer) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            targetToHide.classList.add("backdrop--hidden");
                        } else {
                            targetToHide.classList.remove("backdrop--hidden");
                        }
                    });
                },
                {
                    // options
                    rootMargin: "-100px 0px 0px 0px",
                }
            );

            observer.observe(heroArea);
        }
    }
})();

library.add(
    faBars,
    faSearch,
    faArrowLeftLong,
    faArrowRightLong,
    faX,
    faCaretDown,
    faInstagram,
    faXTwitter,
    faFacebookF,
    faLinkedinIn
);
dom.watch();

Carousel(".block--carousel-container", {
    type: "loop",
    focus: "center",
    autoWidth: true,
    autoHeight: true,
    pagination: false,
    arrows: false,
    autoplay: "pause",
    intersection: {
        inView: {
            autoplay: true,
        },
        outView: {
            autoplay: false,
        },
    },
});

Lightbox();

new Accordion({
    selector: ".collapsiblecontentblock--item--content--panel",
});

LazyReactForm();
